const toMin = (hhmm) => { const m = String(hhmm || "").match(/^(\d{1,2}):(\d{2})$/); return m ? Number(m[1]) * 60 + Number(m[2]) : null; };

export function ruleActive(r, now = new Date()) {
  if (!r || r.enabled === false) return false;
  const day = now.getDay();
  const cur = now.getHours() * 60 + now.getMinutes();
  if (Array.isArray(r.days) && r.days.length && !r.days.includes(day)) return false;
  const a = toMin(r.from), b = toMin(r.to);
  if (a == null || b == null || a === b) return true;
  return a < b ? cur >= a && cur < b : cur >= a || cur < b;
}

export function activeTickerTexts(shop, now = new Date()) {
  const hit = (shop?.display_tickers || []).filter((r) => r && String(r.text || "").trim() && ruleActive(r, now)).map((r) => r.text.trim());
  if (hit.length) return hit;
  const base = String(shop?.display_ticker || "").trim();
  return base ? [base] : [];
}

export function activeSpotlights(shop, products, now = new Date()) {
  return (shop?.display_spotlight || []).filter((s) => {
    if (!ruleActive(s, now)) return false;
    const stock = products ? products[s.product_id]?.stock : s.stock;
    return !(typeof stock === "number" && stock <= 0);
  });
}
